export const MODAL_NAME_CREATE_FONT = 'modalCreateFont';
export const MODAL_NAME_CREATE_SYMBOL = 'modalCreateSymbol';
export const MODAL_NAME_AUTH = 'modalAuth';

export const PAYMENT_MODAL_NAME = 'paymentModal';
